import MobileNavigation from './mobile-navigation';
import { SideMenu } from './side-menu';

export default class BlogNavigation {
  initializeEventListeners = () => {
    (new MobileNavigation()).initializeEventListeners();
    (new SideMenu()).initializeEventListeners();
  };
}
